import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import ContainerResponsive from "../../common/components/ContainerResponsive";
import ShopHeader from "./ShopHeader";

export default function ShopLayout() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ShopHeader />
      <ContainerResponsive>
        <div style={{ paddingTop: 5 }}>
          <Outlet />
        </div>
      </ContainerResponsive>
    </>
  );
}
